import { Http } from 'Core/utils'
import { StateProvince } from 'Core/utils/storeHelpers/types'

import { RegistrationDocument } from 'Portals/Supplier/entities/RegistrationDocument'

import { baseUrl } from './constants'

export const retrieveSupplierRequest = (): Promise<RegistrationDocument.SupplierRequest> =>
	Http.get(`${baseUrl}/me`)

// TODO: should be moved to metadata store
export const retrieveCounties = (): Promise<Entity[]> => Http.get(`/counties`)
// TODO: should be moved to metadata store
export const retrieveCountries = (): Promise<Entity[]> => Http.get(`/countries`)

export const retrieveServices = (): Promise<Entity[]> =>
	Http.get('/supplier-locations/supplier-types')

export const retrieveStateProvinces = (): Promise<StateProvince[]> => Http.get(`${baseUrl}/states`)

export const retrieveDiversityChoices = (): Promise<Entity[]> => Http.get(`${baseUrl}/diversities`)

export const retrieveLegalStructures = (): Promise<Entity[]> =>
	Http.get(`${baseUrl}/legal-structures`)

export const retrieveCertifications = (): Promise<Entity[]> => Http.get(`${baseUrl}/certifications`)

export const retrieveEmrReasons = (): Promise<Entity[]> => Http.get(`${baseUrl}/emr-reasons`)

export const retrieveOshaReasons = (): Promise<Entity[]> => Http.get(`${baseUrl}/osha-reasons`)

export const retrieveEmploymentPolicies = (): Promise<Entity[]> =>
	Http.get(`${baseUrl}/employment-policies`)

export const retrieveIssuesAddressed = (): Promise<Entity[]> => Http.get(`${baseUrl}/safety-issues`)

export const retrieveCsrPrograms = (): Promise<Entity[]> =>
	Http.get(`${baseUrl}/csr-sustainabilities`)

export const retrieveEthicalPolicies = (): Promise<Entity[]> =>
	Http.get(`${baseUrl}/ethical-policies`)

export const saveRegistrationDocument = (
	registrationDocumentId: Key,
	payload: RegistrationDocument.Request
): Promise<void> => Http.put(`${baseUrl}/${registrationDocumentId}`, payload)

export const submitRegistrationDocument = (
	registrationDocumentId: Key,
	payload: RegistrationDocument.Request
): Promise<void> => Http.put(`${baseUrl}/${registrationDocumentId}/submit`, payload)

export const retrieveDocuments = (id: Key): Promise<RegistrationDocument.Document.Basic[]> =>
	Http.get(`${baseUrl}/${id}/uploaded-documents`)

export const uploadDocument = (id: Key, data: RegistrationDocument.Document.Request) => {
	return Http.post(`${baseUrl}/${id}/uploaded-documents`, data, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
}

export const retrieveDocumentTypes = (): Promise<Entity[]> =>
	Http.get(`${baseUrl}/uploaded-documents/types`)

export const downloadDocument = (id: Key, documentId: Key): Promise<Blob> =>
	Http.get(`${baseUrl}/${id}/uploaded-documents/${documentId}/download`, {
		responseType: 'blob'
	})

export const removeDocument = (id: Key, documentId: Key): Promise<void> =>
	Http.delete(`${baseUrl}/${id}/uploaded-documents/${documentId}`)

export const retrieveAdditionalLocations = (
	id: Key
): Promise<RegistrationDocument.AdditionalLocation.Basic[]> =>
	Http.get(`${baseUrl}/${id}/additional-locations`)

export const retrieveAdditionalLocation = ({
	id,
	locationId
}: {
	id: Key
	locationId: Key
}): Promise<RegistrationDocument.AdditionalLocation.Detailed> =>
	Http.get(`${baseUrl}/${id}/additional-locations/${locationId}`)

export const updateAdditionalLocation = (
	id: Key,
	locationId: Key,
	data: RegistrationDocument.AdditionalLocation.Form.Request
): Promise<RegistrationDocument.AdditionalLocation.Form.Request> =>
	Http.put(`${baseUrl}/${id}/additional-locations/${locationId}`, data)

export const deleteAdditionalLocation = (id: Key, locationId: Key): Promise<void> =>
	Http.delete(`${baseUrl}/${id}/additional-locations/${locationId}`)

export const addAdditionalLocation = (
	id: Key,
	data: RegistrationDocument.AdditionalLocation.Form.Request
): Promise<RegistrationDocument.AdditionalLocation.Form.Request> =>
	Http.post(`${baseUrl}/${id}/additional-locations`, data)
